import {IAccountStyleTokens} from "@containers/accountStyle/types";

// Same sizes as the legacy track menu (css/menu-theme.css).
export const sx = {
    root: {
        width: '100%',
    },
    list: {
        marginTop: '10px',
    },
}

export const buildItemSx = (tokens: IAccountStyleTokens) => ({
    position: 'relative',
    padding: '14px 0 9px',
    color: tokens.textMuted,
    borderBottom: `1px solid ${tokens.divider}`,
    transition: 'background-color .2s, color .2s',
    '& .navigate-icon': {
        fontSize: '25px',
        margin: '-2px 0',
        color: 'inherit',
        transition: 'transform .2s',
    },
    '&.new .navigate-icon': {
        fontSize: '29px',
    },
    '&:hover': {
        backgroundColor: tokens.hover,
        color: tokens.text,
    },
    '&:hover .navigate-icon': {
        transform: 'translateY(-2px)',
    },
    '&.active': {
        backgroundColor: tokens.selected,
        color: tokens.text,
    },
    '&.active::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '3px',
        backgroundColor: tokens.activeBar,
    },
})
